export default __webpack_public_path__ + "static/media/soraya-2.2cadca04.png";